import * as React from 'react';
import { SVGProps } from 'react';

const NoNoificationData = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="123"
    height="128"
    viewBox="0 0 123 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_9149_7563)">
      <path
        d="M29.2275 28.9581C30.5545 42.811 39.1968 53.5092 52.4325 57.5553C55.2225 58.4126 55.9371 58.5154 61.0748 58.5154C66.2126 58.5154 66.9611 58.4126 69.6831 57.5896C82.9188 53.5092 91.6292 42.7767 92.9221 28.9581C93.0565 27.5263 94.2706 26.4393 95.7085 26.4634L101.36 26.5579C110.377 26.6951 110.853 26.7636 113.303 28.9239C114.018 29.5754 114.97 30.8441 115.379 31.8042L115.904 32.9065C116.096 33.3095 116.195 33.7502 116.195 34.1966V67.2935C116.195 89.5129 116.059 101.514 115.855 102.337C115.311 104.292 113.507 106.417 111.466 107.48L110.323 108.089C109.889 108.32 109.405 108.441 108.914 108.441H82.6806C63.2184 108.441 55.4267 108.543 54.5761 108.852C53.9296 109.058 47.4308 113.618 40.0815 118.967C32.7661 124.282 26.6757 128.671 26.6076 128.671C26.5055 128.671 26.3694 125.071 26.3014 120.682C26.1993 113.07 26.1653 112.658 25.4167 111.458C23.9196 109.058 22.7968 108.646 17.0126 108.441C12.2151 108.269 11.8068 108.2 10.3097 107.309C8.50636 106.246 7.11134 104.6 6.43084 102.714C6.05656 101.651 5.98851 94.9306 5.98851 67.4649L5.95517 34.1982C5.95472 33.7508 6.05433 33.309 6.24671 32.9051L6.77109 31.8042C7.48561 30.2611 8.37026 29.1982 10.1396 27.8609C11.5005 26.8322 13.9503 26.5236 21.4698 26.5236L26.5091 26.5006C27.9141 26.4942 29.0926 27.5596 29.2275 28.9581Z"
        fill="#99ACC2"
      />
      <path
        d="M15.6516 36.2615C14.3586 37.5302 14.3927 39.2789 15.6856 40.4447C16.4001 41.0962 16.9445 41.2334 18.7138 41.2334C19.9047 41.2334 21.2657 41.062 21.708 40.8562C22.5586 40.479 23.3072 39.2446 23.3072 38.3188C23.3072 37.393 22.5586 36.1586 21.708 35.7814C21.2657 35.5757 19.9047 35.4042 18.6798 35.4042C16.7744 35.4042 16.3661 35.5414 15.6516 36.2615Z"
        fill="white"
      />
      <path
        d="M100.339 35.8157C98.7062 36.6044 98.3999 38.9703 99.7269 40.3419C100.544 41.1305 100.884 41.2334 103.129 41.2334C105.239 41.2334 105.749 41.0962 106.464 40.4447C107.757 39.2789 107.791 37.5302 106.498 36.2615C105.783 35.5071 105.375 35.4042 103.368 35.4385C102.109 35.4385 100.714 35.61 100.339 35.8157Z"
        fill="white"
      />
      <path
        d="M16.2298 47.4063C15.3112 47.8178 14.4946 49.5322 14.7327 50.6981C14.8008 51.1438 15.2771 51.8296 15.7535 52.2068C16.5361 52.824 17.1485 52.8926 23.341 52.8926C29.9419 52.8926 30.078 52.8926 30.9966 52.0696C32.2215 51.041 32.3236 49.1208 31.2008 47.9892C30.4522 47.2692 30.146 47.2349 23.7153 47.1663C20.0406 47.132 16.6722 47.2349 16.2298 47.4063Z"
        fill="white"
      />
      <path
        d="M91.6972 47.5092C89.8599 48.435 89.6217 50.9038 91.2549 52.2068C92.0715 52.824 92.6499 52.8926 98.8424 52.8926C105.001 52.8926 105.613 52.824 106.396 52.2068C106.872 51.8296 107.349 51.1438 107.417 50.6981C107.655 49.4637 106.838 47.7835 105.818 47.4063C104.457 46.892 92.752 46.9605 91.6972 47.5092Z"
        fill="white"
      />
      <path
        d="M16.0943 59.2693C14.5292 60.0922 14.291 62.3553 15.5839 63.7612L16.2644 64.5498H29.0918C41.4769 64.5498 41.9192 64.5155 42.6337 63.864C44.1308 62.4582 43.8246 60.0922 42.0213 59.1664C40.6943 58.4806 17.3532 58.5492 16.0943 59.2693Z"
        fill="white"
      />
      <path
        d="M80.1288 59.1664C78.3255 60.0922 78.0192 62.4582 79.5163 63.864C80.2309 64.5155 80.6732 64.5498 93.0582 64.5498H105.886L106.6 63.7612C107.349 62.9725 107.587 61.4295 107.145 60.2637C106.6 58.8235 105.579 58.7206 92.9902 58.7206C84.0076 58.7206 80.7753 58.8235 80.1288 59.1664Z"
        fill="white"
      />
      <path
        d="M16.2983 70.8599C14.563 71.6142 14.1888 74.1173 15.5838 75.4546L16.3663 76.209H61.1091H105.886L106.6 75.4203C107.383 74.5631 107.587 72.8486 107.009 71.7514C106.839 71.4085 106.192 70.9627 105.614 70.757C104.831 70.4827 91.9016 70.3798 60.939 70.3798C25.1107 70.4141 17.1489 70.4827 16.2983 70.8599Z"
        fill="white"
      />
      <path
        d="M15.5492 83.1703C14.7666 84.0275 14.5624 85.742 15.1409 86.8393C15.311 87.1822 15.9575 87.6279 16.5359 87.8336C18.067 88.3823 104.082 88.3823 105.613 87.8336C106.872 87.3879 107.348 86.6335 107.348 85.0219C107.348 84.2676 107.076 83.6161 106.566 83.136L105.783 82.3817H61.0405H16.2637L15.5492 83.1703Z"
        fill="white"
      />
      <ellipse
        cx="60.9222"
        cy="27.1313"
        rx="26.9222"
        ry="27.1313"
        fill="#99ACC2"
      />
      <path
        d="M64.9059 39.083C64.9059 41.2691 63.0941 43.0413 60.8591 43.0413C58.624 43.0413 56.8122 41.2691 56.8122 39.083M65.2098 14.1455C63.9282 13.39 62.4428 12.958 60.8591 12.958C56.0253 12.958 52.1067 16.9825 52.1067 21.9469V26.1793C52.1067 27.4686 51.8247 28.7414 51.2815 29.9038L49.0533 34.6717C48.1838 36.5323 49.5041 38.6872 51.5136 38.6872H70.2046C72.214 38.6872 73.5343 36.5323 72.6649 34.6717L70.4367 29.9038C69.8935 28.7414 69.6115 27.4686 69.6115 26.1793V24.833"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M68.5415 26.958C72.9598 26.958 76.5415 23.3763 76.5415 18.958C76.5415 14.5397 72.9598 10.958 68.5415 10.958C64.1232 10.958 60.5415 14.5397 60.5415 18.958C60.5415 23.3763 64.1232 26.958 68.5415 26.958Z"
        fill="#99ACC2"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M66.5415 20.9576L70.5415 16.958L66.5415 20.9576ZM66.5415 16.9584L70.5415 20.958L66.5415 16.9584Z"
        fill="#E5E9F0"
      />
      <path
        d="M66.5415 20.9576L70.5415 16.958M66.5415 16.9584L70.5415 20.958"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_9149_7563">
        <rect width="123" height="128" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default NoNoificationData;
